Object.defineProperty(exports, Symbol.toStringTag, {
  value: 'Module'
});
var carrier = require('./carrier.js');
var scope = require('./scope.js');

/** Get the default current scope. */
function getDefaultCurrentScope() {
  return carrier.getGlobalSingleton('defaultCurrentScope', function () {
    return new scope.Scope();
  });
}

/** Get the default isolation scope. */
function getDefaultIsolationScope() {
  return carrier.getGlobalSingleton('defaultIsolationScope', function () {
    return new scope.Scope();
  });
}
exports.getDefaultCurrentScope = getDefaultCurrentScope;
exports.getDefaultIsolationScope = getDefaultIsolationScope;